import styled from 'styled-components';

export default styled.div`
  font-size: 16px;
  line-height: 1.6rem;

  h2 {
    margin-top: 16px;
    font-size: 17px;
  }

  p {
    margin-top: 1rem;
    font-size: 16px;
    line-height: initial;
  }

  ul,
  ol {
    margin-top: 1rem;
    list-style-position: inside;

    li {
      padding-left: 15px;
      padding-bottom: 5px;
      font-size: 16px;
    }
  }

  ul {
    list-style-type: disc;
  }

  img {
    width: 100%;
  }

  div {
    &.pages-section {
      margin-top: 1rem;
      font-size: 16px;
      line-height: 17px;
      color: ${({ theme }) => theme.colors.text.default};
    }
  }

  table {
    tbody {
      tr {
        th {
          padding-bottom: 8px;
          border-bottom: 1px solid lightgrey;
        }

        td {
          padding: 5px;
        }
      }
    }
  }
`;
